import axios from 'axios';

export const SEND_INQUIRY_MAIL = 'SEND_INQUIRY_MAIL';




export function sendInquiryMailR(formMessages) {
  console.log("sendInquiryMailR");
  return {
    type: SEND_INQUIRY_MAIL,
    payload: axios.post('/api/mails/design-inquiry', formMessages).then(({ data }) => data),
  };
}

